import React, { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import UcpSign from '../components/ucp-sign/ucp-sign';
import LoadDocBtn from '../modules/load-doc-btn';
import { useAppDispatch } from '../store';
import { getUcpDoc, signUcp } from '../store/actions/operations-sign';
import { fetchIdOrder } from '../store/actions/order-detailed';
import { setOperationResult } from '../store/actions/sign-result';
import { signPaymentPositionsList } from '../store/selectors/sign-positions-list';
import { RootState } from '../types';
import currencyFormat from '../utils/currencyFormat';
import { downloadFile, getPdfFromBase64 } from '../utils/files/downloadFile';
import { useSign } from 'hooks';

const SignOrderProcessOrderContainer = () => {
  const history = useHistory();
  const [loadingSign, setLoadingSign] = useState(false);
  const dispatch = useAppDispatch();
  const params = useParams<{ id: string }>();
  const authState = useSelector((state: RootState) => state.auth);
  const signingPaymentItems = useSelector(signPaymentPositionsList);
  const order = useSelector((state: RootState) => state.orderDetailed.data);
  const decisionId = useSelector(
    (state: RootState) => state.operationsSign.data.orderUcp.decisionId
  );
  const decisionDoc = useSelector(
    (s: RootState) => s.operationsSign.data.orderUcp.decisionDoc
  );
  const decisionHash = useSelector(
    (state: RootState) => state.operationsSign.data.orderUcp.decisionHash
  );

  const {
    certificatesList,
    selectedCertificate,
    signEntity,
    onUserSelectCertificate,
    usersCertificates,
  } = useSign();

  const currentCert = useMemo(() => {
    return usersCertificates.find(
      (certificate) => certificate.thumbprint === selectedCertificate?.value
    );
  }, [usersCertificates, selectedCertificate]);

  useEffect(() => {
    if (decisionId) dispatch(getUcpDoc({ id: decisionId, withHash: true }));
  }, [decisionId]);

  useEffect(() => {
    dispatch(fetchIdOrder({ id: parseInt(params.id, 10) }));
  }, []);

  const onClose = () => {
    history.push('/orders');
  };

  const onSubmit = async () => {
    setLoadingSign(true);
    if (currentCert && decisionHash && decisionId) {
      const { pdfSigned } = await signEntity(decisionHash);
      if (pdfSigned) {
        dispatch(
          signUcp({
            hash: decisionHash,
            issuingDecisionId: decisionId,
            signature: pdfSigned,
            docType:
              authState.account.id === order.order?.initiatorId
                ? 'SIGNED_DECISION'
                : 'PAYMENT_SIGNED',
          })
        ).then((action) => {
          const status = action.meta.requestStatus === 'fulfilled';
          dispatch(setOperationResult({ name: 'orderUcp', status }));
          history.push(`/orders/${params.id}/sign/result`, {
            title:
              order.order?.initiatorId === authState.account.id
                ? `Решение о выпуске успешно подписано`
                : `Вы успешно приобрели товарные токены`,
            text:
              order.order?.initiatorId === authState.account.id
                ? 'Теперь необходимо дождаться, пока приобретатель подпишет согласие'
                : 'Теперь необходимо дождаться подтверждения отгрузки товара',
          });
        });
      }
    }
  };

  const getTotalSum = () => {
    let sum = 0;
    signingPaymentItems?.forEach((item) => {
      sum += item.price;
    });
    return sum;
  };

  const getDecisionDocs = () => {
    const docs = [];

    if (decisionDoc && decisionId) {
      docs.push(
        <a
          href="https://dev.gp7.digital/documents/DecisionReleaseHybrid.pdf"
          target="_blank"
          download
          rel="noreferrer"
        >
          <LoadDocBtn
            title={`Решение о выпуске №${decisionId}`}
            onSpecDownload={() => {
              // const resultBlob = getPdfFromBase64(decisionDoc);
              // downloadFile(
              //   resultBlob,
              //   `Решение о выпуске №${decisionId}.pdf`,
              //   "application/pdf"
              // );
            }}
            sig={authState.account.id !== order.order?.initiatorId}
            onSpecDownloadSig={() => {
              // const resultBlob = getPdfFromBase64(decisionDoc);
              // downloadFile(
              //   resultBlob,
              //   `Решение о выпуске №${decisionId}.pdf.sig`,
              //   "application/pdf"
              // );
            }}
          />
        </a>
      );

      authState.account.id !== order.order?.initiatorId &&
        docs.push(
          <LoadDocBtn
            title={`Согласие на приобретение`}
            onSpecDownload={() => {
              const resultBlob = getPdfFromBase64(decisionDoc);
              downloadFile(
                resultBlob,
                `Согласие на приобретение.pdf`,
                'application/pdf'
              );
            }}
          />
        );
    }
    return docs;
  };

  return (
    <UcpSign
      isUcpIssuing={true}
      onCertSelect={onUserSelectCertificate}
      decisionDocs={getDecisionDocs()}
      selectedCert={selectedCertificate}
      disabled={loadingSign || !selectedCertificate || !decisionHash}
      recipientOrderInfo={{
        inn: order.order?.recipientTIN ?? '',
        name: order.order?.recipient ?? '',
      }}
      initiatorOrderInfo={{
        inn: order.order?.initiatorTIN || '',
        name: order.order?.initiator || '',
        id: order.order?.initiatorId || 0,
      }}
      totalSum={getTotalSum()}
      onClose={onClose}
      onSubmit={onSubmit}
      certsOptions={certificatesList}
      detailsList={
        signingPaymentItems
          ? signingPaymentItems.map((item) => ({
              refNumber: item.name,
              sum: currencyFormat(item.priceWithVat),
            }))
          : []
      }
    />
  );
};

export default SignOrderProcessOrderContainer;
